import React, { useState } from "react";
import { AccordionItemProps } from "./AccordionItem";
import styles from "../../../styles/common/Accordion.module.scss";

interface AccordionProps {
    children:
        | React.ReactElement<AccordionItemProps>[]
        | React.ReactElement<AccordionItemProps>;
    openIndexDefault?: number;
    className?: string;
}

const Accordion: React.FC<AccordionProps> = ({
    openIndexDefault,
    children,
    className = "",
}) => {
    const [openIndex, setOpenIndex] = useState<number>(openIndexDefault ?? -1);

    const handleItemClick = (index: number) => {
        setOpenIndex(index === openIndex ? -1 : index);
    };

    return (
        <div className={`${styles.accordion} ${className}`}>
            {React.Children.map(children, (child, index) => {
                return React.cloneElement(child, {
                    isOpen: openIndex === index,
                    onItemClick: () => handleItemClick(index),
                });
            })}
        </div>
    );
};

export default Accordion;
